export var KEYS = {
  LEFT: 37,
  RIGHT: 39,
};



// WEBPACK FOOTER //
// ./src/utils/keys.js